export const trackingParameters = {
  CLICK: 'click',
  IMPRESSION: 'impression',
  LOAD: 'tracking',
};

export const MANGO_PARAMETERS = {
  CLIENT_NAME: 'Marriott Media Network',
  URL: '/mi/mango/beacon',
};
